import z from 'zod'

const assetFolderSchema = z.enum(['company-logos'])
export type AssetFolder = z.infer<typeof assetFolderSchema>

export const uploadAssetRequestSchema = z.object({
  filename: z.string(),
  folder: assetFolderSchema,
})

export type UploadAssetRequest = z.infer<typeof uploadAssetRequestSchema> & { file: File }
export type UploadAssetResponse = {
  key: string
}
